<div class="container">
  <div class="row">  
      <div class="col-lg-2 col-md-3 col-sm-0">
        &nbsp;
      </div>
    <div class="col-lg-8 col-md-6 col-sm-12">
        <div id="textDiv" #textDiv class="center-div">      
          <h1>Welcome</h1>
          <p>You've reached Assenheimers.com, the Internet-connected sandbox for the Assenheimer family. Inside this site you'll find links, resources and information that pertain to our family and our work.</p>  

          <p>If you wish to contact Scott, please use the email address in the <a class="soccerbutton" [routerLink]="['/profiles/scott/bio']" routerLinkActive="router-link-active"  >Bio</a> link.</p>
          <p>If you are looking for Soccer Training Materials, visit <a class="soccerbutton" href="http://www.soccr.io" target='_blank'>www.soccr.io</a>.</p>          
          

        </div>
    </div>  
    <div class="col-lg-2 col-md-3 col-sm-0">
        &nbsp;
      </div>      
  </div>
</div>
<div style="background-image: url(../assets/images.background/blue_art.low.jpg); position: fixed; right: 0; bottom: 0; z-index: -100; width: auto; height: auto; background-repeat: no-repeat; background-size: cover; min-height: 100%; min-width: 100%;"></div>